import { PropsWithChildren, createContext, useContext, useState } from "react"

import { SortOrder } from "../hooks/useSort/helpers"

type ContextValue = {
  sortBy: string | null
  sortOrder: SortOrder | null
  setSortBy: (sortBy: string | null) => void
  setSortOrder: (sortOrder: SortOrder | null) => void
  filters: Record<string, string[]>
  setFilters: (key: string, filters: string[]) => void
  currentFilterKey: string | null
  setCurrentFilterKey: (filterKey: string | null) => void
}

export const SortFilterContext = createContext<ContextValue | undefined>(
  undefined
)

export function SortFilterProvider({ children }: PropsWithChildren) {
  const [sortBy, setSortBy] = useState<string | null>(null)
  const [sortOrder, setSortOrder] = useState<SortOrder | null>(null)

  const [filters, setFiltersState] = useState<Record<string, string[]>>({})
  const setFilters = (key: string, filterValues: string[]) => {
    setFiltersState((prev) => ({
      ...prev,
      [key]: filterValues,
    }))
  }

  const [currentFilterKey, setCurrentFilterKey] = useState<string | null>(null)

  return (
    <SortFilterContext.Provider
      value={{
        sortBy,
        sortOrder,
        setSortBy,
        setSortOrder,
        filters,
        setFilters,
        currentFilterKey,
        setCurrentFilterKey,
      }}
    >
      {children}
    </SortFilterContext.Provider>
  )
}

export function useSortFilterState() {
  const context = useContext(SortFilterContext)
  if (!context) {
    throw new Error("useSortFilter must be used within a SortFilterProvider")
  }
  return context
}
